import MetodosGlobais from './MetodosGlobais'
import vue from 'vue'

vue.filter('thousandSeparator', MetodosGlobais.thousandSeparator)
